// React
import React, { useEffect, useState, useRef, useMemo } from 'react';

// Components
import RollbackModal from './rollBack/rollbackModal';
import ShareModal from './sharePopup';
import Header from '@custom/Header/Header'
import Barcode from 'react-barcode'
import { QRCodeCanvas } from 'qrcode.react';
import ImagePreview from './ImagePreview';

// Assets
import { phoneIcon, mailIcon, mapIcon, downloadIcon, printerIcon, threeDotIcon, mailIconwhite, mapIconWhite, phoneIconWhite, signIcon, rollbackIcon, shareIcon, websiteIcon } from '../../ui/assets/svgIcons/icon'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { apiRequest } from '@custom/Utils/config/apiRequest'
import { _reportUrls } from '@custom/Utils/constants/apiUrls'

import './Preview.css'
import { _reportStatus, _roleType } from '@custom/Utils/constants/appConstants';
import { customStyle, formatDate, formatDays, formatTime } from '@custom/Utils/utils';
import { baseURL } from '@custom/constant';
import { HospitalDetail } from '@custom/Utils/constants/interfaces';
import { Icon, Loader } from '@ohif/ui';
import { useTheme } from "../../ui/src/contextProviders"
import { calculateAge } from '@custom/Utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import previewReportDownloadApi from '@custom/rtk-apis/report/previewReportDownload';

// Ui
export default function PreviewReport() {
  let { reportId } = useParams();
  const printRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const result = useSelector((state: RootState) => state.previewReportDownloadResponse);
  const userRole = sessionStorage.getItem("role") || localStorage.getItem("role");
  // States
  const [reportDet, setReportDet] = useState<HospitalDetail>({});
  const [showMenu, setShowMenu] = useState(false)
  const [imgPreviewPg, setImgPreviewPg] = useState(false);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [impressions, setImpressions] = useState('');
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');

  useEffect(() => {
    fetchReportDet();
  }, [reportId]);

  // Fetch report details
  const fetchReportDet = async () => {
    setIsLoading(true);
    try {
      const { status, result } = await apiRequest({
        method: "POST",
        endUrl: _reportUrls.getReport,
        body: { reportId }

      });

      if (status) {
        setReportDet(result);
      } else {
        console.error('Failed to fetch report data');
      }
    } catch (err) {
      console.error('An error occurred: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const adjustTextareaHeight = () => {
    const textarea = document.getElementById('findingsText');
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
      textarea.style.overflow = 'hidden';
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
    window.addEventListener('resize', adjustTextareaHeight);
    return () => {
      window.removeEventListener('resize', adjustTextareaHeight);
    };
  }, [reportDet?.templateHTML]);

  // helpers
  const disableInputs = (html) => {
    if (!html) return '';

    let htmlString = html;
    if (typeof html === 'object' && html?.html) {
      htmlString = html?.html;
    }
    else {
      htmlString = html
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const tooltips = doc.getElementsByClassName('ql-tooltip');
    while (tooltips.length > 0) {
      tooltips[0].parentNode.removeChild(tooltips[0]);
    }
    const hiddenElements = doc.getElementsByClassName('ql-hidden');
    while (hiddenElements.length > 0) {
      hiddenElements[0].parentNode.removeChild(hiddenElements[0]);
    }

    const inputs = doc.getElementsByTagName('input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('disabled', 'disabled');
    }
    const textareas = doc.getElementsByTagName('textarea');
    for (let i = 0; i < textareas.length; i++) {
      textareas[i].setAttribute('disabled', 'disabled');
    }
    const selects = doc.getElementsByTagName('select');
    for (let i = 0; i < selects.length; i++) {
      selects[i].setAttribute('disabled', 'disabled');
    }

    return doc.body.innerHTML;
  };

  const printAsPdf = async () => {
    const printWindow = window.open('', '_blank');

    printWindow.document.write(`
      <html>
        <head>
          <title>Preparing PDF</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              text-align: center;
              padding-top: 100px;
            }
            .loader {
              border: 8px solid #f3f3f3;
              border-top: 8px solid #3498db;
              border-radius: 50%;
              width: 60px;
              height: 60px;
              animation: spin 1s linear infinite;
              margin: 20px auto;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          </style>
        </head>
        <body>
          <h3>Processing your request. PDF will open shortly...</h3>
          <div class="loader"></div>
        </body>
      </html>
    `);
    printWindow.document.close();

    try {
      setIsPrinting(true);
      const response = await dispatch(previewReportDownloadApi(reportId));

      if (previewReportDownloadApi.fulfilled.match(response)) {
        const downloadResult = response.payload;

        if (downloadResult?.pdfUrl) {
          printWindow.location.href = downloadResult.pdfUrl;
        } else {
          printWindow.close();
          alert("Failed to retrieve the PDF. Please try again.");
        }
      } else {
        printWindow.close();
        alert("Failed to retrieve the PDF. Please try again.");
      }
    } catch (error) {
      printWindow.close();
      alert("An error occurred while preparing the PDF for printing. Please try again.");
    } finally {
      setIsPrinting(false);
    }
  };

  const getWaterStyle = (status) => {
    switch (status) {
      case _reportStatus.Draft:
        return `rgba(158, 102, 255, 0.1)`
      case _reportStatus.Completed:
        return `rgba(52, 199, 89, 0.1)`
      case _reportStatus.Authorized:
        return `rgba(52, 199, 89, 0.1)`
      case _reportStatus.SentForReview:
        return `rgba(52, 199, 89, 0.1)`
    }
  }

  //rollbackmodal and sharemodal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isshareModalOpen, setIsshareModalOpen] = useState(false);
  const isDarkMode = useTheme();

  const handleOpenModal = () => {
    if (reportDet?.status === _reportStatus.Authorized) {
      setShowMenu(false)
      setIsModalOpen(true);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleShare = () => {
    if (reportDet?.status === _reportStatus.Authorized) {
      setShowMenu(false)
      setIsshareModalOpen(true);
    }
  }

  const handleCloseshareModal = () => {
    setIsshareModalOpen(false)
  }
  //hospital details data
  const { hospitalDetail } = reportDet;

  const containerStyle = {
    width: "95.7%",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  };

  const h2Style = {
    flexGrow: 1,
    textAlign: 'center' as 'center',
    fontSize: '1.875rem', // This is for 3xl size
    fontWeight: '600',
    color: isDarkMode?.isDarkMode ? "#ffffff" : "#49475A"
  };

  // Function to dynamically set button color based on priority
  const getPriorityStyle = (priority) => {
    switch (priority) {
      case 'Routine':
        return { border: '1px solid #28a745', color: '#28a745' }; // Green
      case 'Priority':
        return { border: '1px solid #007bff', color: '#007bff' }; // Blue
      case 'Critical':
        return { border: '1px solid #FF5C5C', color: '#FF5C5C' }; // Red
      default:
        return { border: '1px solid #ccc', color: '#ccc' }; // Default grey if no priority
    }
  };

  const buttonStyle = {
    backgroundColor: 'transparent',
    padding: '5px 15px',
    borderRadius: '4px',
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    ...getPriorityStyle(reportDet?.priority), // Merging dynamic styles
  };

  const dotStyle = {
    height: '8px',
    width: '8px',
    backgroundColor: buttonStyle.color,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '8px',
  };

  const handleIsBackFunctionality = () => {
    if (location?.state?.from === '/rollbacklist') {
      navigate('/rollbacklist');
    } else if (location?.state?.from) {
      navigate(`/studyresearch?refetch=true`);
    } else if (location?.state?.fromReportsScreen) {
      navigate(-1)
    } else {
      window.location.href = `/patient/detail/${reportDet?.uhid}`;
    }
  }

  const dob = reportDet?.age;
  const age = useMemo(() => calculateAge(dob), [dob]);

  const getAddress = (hospitalDetails) => {
    if (hospitalDetails) {
      const { address, country, state, city, zipCode } = hospitalDetails;

      let fullAddress = [address, city, state, country, zipCode]
        .filter(Boolean)
        .join(', ');

      return fullAddress;
    }
    return '';
  };

  const handleDownloadPDF = async () => {
    try {
      setIsLoading(true);

      const response = await dispatch(previewReportDownloadApi(reportId));

      if (previewReportDownloadApi.fulfilled.match(response)) {
        const downloadResult = response.payload;

          const pdfResponse = await fetch(downloadResult.pdfUrl, {
            method: 'GET',
            headers: {
              Accept: 'application/pdf',
            },
          });

          if (!pdfResponse.ok) {
            throw new Error(`Failed to fetch PDF: ${pdfResponse.status} ${pdfResponse.statusText}`);
          }

          const blob = await pdfResponse.blob();
          if (!blob || blob.size === 0) {
            throw new Error('Invalid or empty PDF blob');
          }

          const blobUrl = window.URL.createObjectURL(blob);
          const fileName = `${reportDet?.name || 'report'}.pdf`;
          const link = document.createElement('a');
          link.href = blobUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);

          link.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          }));

          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          }, 100);
      } else {
        console.error('API request failed:', response.error?.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error downloading PDF:', error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cleanPrefixFromName = (name = ''): string => {
    return name.replace(/^(dr\.?|doctor|doc\.?)\s*/i, '');
  };

  // Check if any footerTemplate value is non-empty
  const hasFooterTemplateData = reportDet?.signatureDetail?.footerTemplate && Object.values(reportDet.signatureDetail.footerTemplate).some(value => value && value !== "");

  return (

    <>
      {/* <RollbackPreview/> */}
      <div
        className={`page page__full ${isDarkMode?.isDarkMode ? "dark-mode" : ""}`}
        style={isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground}
      >
        <Header isBack={true} handleIsBackFunctionality={handleIsBackFunctionality} title={'Report Preview'} />
        <div className='page__body'>
          <div className='details'>
            <div className='form form--innersec'>
              <section className='form__section' style={{ paddingTop: "17px" }}>
                <div className='flex items-center justify-between' style={{ marginBottom: isLoading ? '10px' : '-20px' }}>
                  <h1></h1>
                  <div className='flex flex-row items-center gap-2'>
                    <QRCodeCanvas
                      value={`${baseURL}/report/preview/${reportDet?.reportNumber}`}  // The URL to encode in the QR code
                      size={56}   // Adjust the size as needed
                      fgColor={"#000000"} // QR code color
                      level="H"   // Error correction level
                      style={{ cursor: 'pointer' }} // Make the QR code clickable
                    />
                    <button onClick={handleDownloadPDF} className={`bg-green-500 ${isDarkMode?.isDarkMode ? "text-white" : "text-black"} px-2 py-1 rounded border border-black flex gap-2 items-center text-[14px] font-semibold`}>
                      <img src={downloadIcon} style={isDarkMode?.isDarkMode ? null : { filter: "invert(1)" }} />
                      Download
                    </button>
                    <button onClick={() => printAsPdf()} className={`bg-green-500 ${isDarkMode?.isDarkMode ? "text-white" : "text-black"} px-2 py-1 rounded border border-black flex gap-2 items-center text-[14px] font-semibold`}>
                      <img src={printerIcon} style={isDarkMode?.isDarkMode ? { filter: 'invert(1)' } : null} />
                      Print
                    </button>

                    {reportDet?.status === 'Authorized' ? (
                      <div className='relative'>
                        <img className='cursor-pointer p-2 mx-2' src={threeDotIcon} onClick={() => setShowMenu(!showMenu)} style={isDarkMode?.isDarkMode ? { filter: "invert(1)" } : null} />

                        {
                          showMenu &&
                          <div className={`absolute p-2 ${"bg-white"}`} style={{ width: '120px', right: '10px', zIndex: 3, boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.19)' }}>
                            <div className='flex flex-row items-center gap-2 cursor-pointer mb-2' onClick={handleShare}>
                              <img src={shareIcon} style={isDarkMode?.isDarkMode ? { filter: 'invert(1)' } : null} />
                              <p className={`text-[12px] font-regular ${isDarkMode?.isDarkMode ? "text-white" : "text-black"}`}>Share</p>
                            </div>
                            {userRole !== 'Front Desk' && userRole !== 'Nurse' && userRole !== 'Resident' && <div className={`flex flex-row items-center gap-2 cursor-pointer mb-2 ${isDarkMode?.isDarkMode ? "text-white" : "text-black"}`} onClick={handleOpenModal}>
                              <img src={rollbackIcon} style={isDarkMode?.isDarkMode ? { filter: 'invert(1)' } : null} />
                              <p className='text-[12px] font-regular'>Rollback</p>
                            </div>}
                          </div>
                        }
                      </div>
                    ) : null}

                  </div>
                </div>
                {
                  false ? <ImagePreview setImgPreviewPg={setImgPreviewPg} images={reportDet?.images} reportDet={reportDet} setReportDet={setReportDet} /> :
                    <div ref={printRef} className='watermark-container2-transparent' style={{ overflowX: 'auto', paddingTop: "0px" }} onClick={() => setShowMenu(false)}>
                      <div className="px-1 content" style={{ minWidth: '1200px', color: '#49475A' }}>

                        <section className="flex flex-row p-2">
                          <div className="basic-1/3 p-4">
                            <div className="h-full">
                              <div className='flex flex-row h-full w-full'>
                                <div className="block mx-auto" style={{ width: '150px' }}>
                                  {hospitalDetail?.hospitalLogo ? (
                                    <img src={hospitalDetail?.hospitalLogo} alt="Hospital Logo" className='block mx-auto' />
                                  ) : (
                                    <Icon name="DummyLogo"></Icon>
                                  )}
                                </div>
                                <div className='border-l-2 border-[#0F8491] ml-4 h-full'></div>
                              </div>
                            </div>
                          </div>
                          <div className="basic-2/3 p-4 w-full ml-4">
                            <div>
                              <p className={`${"text-[#0F8491]"} text-3xl font-semibold`}>{hospitalDetail?.hospitalHeader?.hospitalName ? hospitalDetail?.hospitalHeader?.hospitalName : hospitalDetail?.hospitalName}</p>
                              <ul className="">
                                {reportDet?.hospitalDetail?.specialitites?.map((item, index) => (
                                  <li className={`text-[14px] ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : "text-[#49475A]"} relative pl-4`} key={index}>
                                    <span className={`absolute left-0 top-1 ${isDarkMode?.isDarkMode ? "text-white" : "text-black"}`}>•</span>
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div className={`flex flex-row gap-4 border-t-2 ${isDarkMode?.isDarkMode ? "border-[#ffffff]" : "border-[#0F8491]"} pt-2 mt-2`}>
                              {(hospitalDetail?.hospitalHeader?.contactNumber || hospitalDetail?.contactNumber) && (
                                <div className='flex flex-row gap-2'>
                                  <img src={isDarkMode?.isDarkMode ? phoneIconWhite : phoneIcon} alt="" />
                                  <p className={`text-[14px] font-normal ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : "color-[#535353]"}`}>{hospitalDetail?.hospitalHeader?.contactNumberCountryCode ? hospitalDetail?.hospitalHeader?.contactNumberCountryCode : hospitalDetail?.contactNumberCountryCode} {hospitalDetail?.hospitalHeader?.contactNumber ? hospitalDetail?.hospitalHeader?.contactNumber : hospitalDetail?.contactNumber}</p>
                                </div>
                              )}
                              {(hospitalDetail?.hospitalHeader?.email || hospitalDetail?.hospitalEmailId) && (
                                <div className='flex flex-row gap-2'>
                                  <img src={isDarkMode?.isDarkMode ? mailIconwhite : mailIcon} alt="" />
                                  <p className={`text-[14px] font-normal ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : "color-[#535353]"}`}>{hospitalDetail?.hospitalHeader?.email ? hospitalDetail?.hospitalHeader?.email : hospitalDetail?.hospitalEmailId}</p>
                                </div>
                              )}
                              {(hospitalDetail?.hospitalHeader?.address || hospitalDetail?.address) && (
                                <div className='flex flex-row gap-2'>
                                  <img src={isDarkMode?.isDarkMode ? mapIconWhite : mapIcon} alt="" />
                                  <p className={`text-[14px] font-normal ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : "color-[#535353]"}`}>{getAddress(hospitalDetail)}</p>
                                </div>
                              )}
                              {hospitalDetail?.hospitalHeader?.website || hospitalDetail?.website && (
                                <div className='flex flex-row gap-2'>
                                  <img src={websiteIcon} alt="" />
                                  <p className={`text-[14px] font-normal ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : "color-[#535353]"}`}>{hospitalDetail?.hospitalHeader?.website ? hospitalDetail?.hospitalHeader?.website : hospitalDetail?.website} </p>
                                </div>
                              )}
                            </div>

                          </div>
                        </section>

                        <section className='bg-[#0F8491] p-2'>
                          <p className='text-[17.53px] font-semibold text-white text-center'>Report</p>
                        </section>

                        <section className='px-2 py-4'>
                          <div className="flex flex-row" style={{ columnGap: "1rem" }}>

                            <div className=" flex flex-col justify-start w-1/4">
                              <div className="flex flex-row gap-6">
                                <div className="flex-none">
                                  <p className='text-[24px] font-semibold mb-4 text-[#49475A]'>
                                    {reportDet?.name
                                      ? reportDet.name
                                        .split(' ')
                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                        .join(' ')
                                      : '---'}
                                  </p>
                                  <p className='text-[13px] font-semibold'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Patient ID :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.patientId || "---"}</span>
                                  </p>
                                </div>
                                <div className="flex-1 mt-1">
                                  <p className='text-[13px] font-semibold mb-4'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Date :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{formatDate(reportDet?.date) || "---"}</span>
                                  </p>
                                  <p className='text-[13px] font-semibold'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Gender :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.gender || "---"}</span>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="flex">
                              <div className='border-l-2 border-[#0F8491] mx-2 h-full' style={{ width: "2px", backgroundColor: "#0F8491" }}></div>
                            </div>

                            <div className="w-1/4 flex flex-col justify-start mt-1">
                              <div className="flex flex-row gap-6">
                                <div className="flex-none">
                                  <p className='text-[13px] font-semibold mb-4'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Age :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.age ? age : "---"}</span>
                                  </p>
                                  <p className='text-[13px] font-semibold'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Blood Group :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.patientDetail?.bloodGroup || "---"}</span>
                                  </p>
                                </div>
                                <div className="flex-1 flex flex-col justify-start mt-1">
                                  <p className='text-[13px] font-semibold mb-4'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Ph No. :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>
                                      {reportDet?.patientDetail
                                        ? `${reportDet?.patientDetail?.contactInfo?.dialCode} ${reportDet?.patientDetail?.contactInfo?.mobileNo}`
                                        : "---"}
                                    </span>
                                  </p>
                                  <p className='text-[13px] font-semibold'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>WhatsApp No. :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>
                                      {reportDet?.patientDetail
                                        ? `${reportDet?.patientDetail?.contactInfo?.whatsappNoDialCode} ${reportDet?.patientDetail?.contactInfo?.whatsappNo}`
                                        : "---"}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="flex">
                              <div className='border-l-2 border-[#0F8491] mx-2 h-full' style={{ width: "2px", backgroundColor: "#0F8491" }}></div>
                            </div>

                            <div className="w-1/2 flex flex-col justify-start">
                              <div className="flex flex-row gap-6">
                                <div className="flex-none flex flex-col justify-start mt-1">
                                  <p className='text-[13px] font-semibold mb-4'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Height :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.patientDetail?.height ? reportDet?.patientDetail?.height + ' ' + 'cm' : "---"}

                                    </span>
                                  </p>
                                  <p className='text-[13px] font-semibold'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Weight :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.patientDetail?.weight ? reportDet?.patientDetail?.weight + ' ' + 'kg' : "---"}</span>
                                  </p>
                                </div>
                                <div className="flex-1 flex flex-col justify-start mt-1">
                                  <p className='text-[13px] font-semibold mb-4'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Consulting Doctor :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.patientDetail?.referPhysicianInfo?.name || "---"}</span>
                                  </p>
                                  <p className='text-[13px] font-semibold'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>Modality Type :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.modality || "---"}</span>
                                  </p>
                                </div>
                                <div className="flex-1 text-center items-center flex flex-col justify-center">
                                  <p className='text-[13px] font-semibold mb-1'>
                                    <span className={`${isDarkMode?.isDarkMode ? "text-[#ffffff]" : 'text-[#49475A]'}`}>UHID :</span>
                                    <span className={`font-normal ml-2  ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : ""}`}>{reportDet?.uhid || "---"}</span>
                                  </p>
                                  {reportDet?.uhid && <Barcode displayValue={false} width={1.2} height={50} value={reportDet?.uhid} />}
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>


                        <div style={containerStyle}>
                          <h2 style={h2Style}>{reportDet?.reportName || ''}</h2>
                          {reportDet?.priority && (
                            role !== _roleType.pathologist && role !== _roleType.technician &&
                              <button style={buttonStyle}>
                                <span style={dotStyle}></span>
                                {reportDet?.priority}
                              </button>
                          )}
                        </div>
                        <h3 className="text-xl font-semibold mb-2 font-sans">Findings</h3>
                        <section
                          id="html-render-preview"
                          className="mb-4"
                          style={{ pointerEvents: 'none', userSelect: 'none' }}
                          dangerouslySetInnerHTML={{
                            __html: `
                                ${disableInputs(reportDet?.templateHTML) || ''}
                              `,
                          }}
                        ></section>

                        {reportDet?.addendum ? (
                          <div>
                            <h3 className="text-xl font-semibold mb-2 font-sans">Addendum</h3>
                            <textarea
                              id='addendum'
                              className={`w-full p-2 border border-gray-300 rounded bg-transparent ${
                                isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                              }`}
                              disabled
                              rows={4}
                              value={reportDet?.addendum}
                            ></textarea>
                          </div>
                        ) : null}

                        {reportDet?.impressions ? (
                          <div>
                            <h3 className="text-xl font-semibold mb-2 font-sans">Impression</h3>
                            <textarea
                              id='impression'
                              className={`w-full p-2 border border-gray-300 rounded bg-transparent ${
                                isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                              }`}
                              disabled
                              rows={4}
                              value={reportDet?.impressions}
                            ></textarea>
                          </div>
                        ) : null}

                        {(reportDet?.status === "Draft" || reportDet?.status === "Completed" || reportDet?.status === "Send for Review") && (
                          <div className="mb-4">
                            <label htmlFor="comment" className="block font-bold mb-2">Comment (For internal use only)</label>
                            <textarea
                              id="comment"
                              rows={3}
                              cols={105}
                              disabled
                              value={reportDet?.comment}
                              className={`w-full p-2 border border-gray-300 rounded bg-transparent ${
                                isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                              }`}
                            ></textarea>
                          </div>
                        )}

                        {reportDet?.rollbackStatus && (
                          <div className="mx-5 p-2 mb-2 shadow-sm mt-8" style={{ backgroundColor: '#84b7d5ff' }}>
                            <p className="text-lg" style={{ color: '#fff' }}>
                              ⚠️ <strong>Important</strong>: The earlier report has been modified and is no longer valid. This updated report is the final and correct version.
                            </p>
                          </div>
                        )}

                        {(reportDet?.status === _reportStatus.Authorized) && (
                          <>
                            <section className='mb-4'>
                              <div className='border-b-2 border-[#49475A] pt-2 mt-2 mb-4' style={{ color: '#49475A' }}>
                              </div>
                              <img src={reportDet?.signatureDetail?.signature} alt="Signature" style={{ width: '150px', height: '100px' }} />
                            </section>

                            <section className='mb-2 border-b-2 border-[#49475A] pt-2 mt-2 mb-4' style={{ color: '#49475A' }}>
                              {hasFooterTemplateData ? (
                                <>
                                  <p className="text-[22px] font-semibold">
                                    {reportDet?.signatureDetail?.footerTemplate?.name ? `Dr. ${cleanPrefixFromName(reportDet.signatureDetail.footerTemplate.name)}` : ''}
                                    {reportDet?.signatureDetail?.footerTemplate?.qualification && `, ${reportDet.signatureDetail.footerTemplate.qualification}`}
                                  </p>
                                  {reportDet?.signatureDetail?.footerTemplate?.role && (
                                    <p className={`text-[16px] font-normal mb-1 m-0 ${isDarkMode?.isDarkMode ? 'text-white' : 'text-black'}`}>
                                      {reportDet.signatureDetail.footerTemplate.role.trim()}
                                    </p>
                                  )}
                                  {reportDet?.signatureDetail?.footerTemplate?.license && (
                                    <p
                                      className={`text-[16px] font-normal mb-1 m-0 ${
                                        isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                                      }`}
                                    >
                                      <span className="font-bold">License Number -</span>{' '}
                                      {reportDet.signatureDetail.footerTemplate.license.trim()}
                                    </p>
                                  )}
                                  {reportDet?.signatureDetail?.footerTemplate?.hprId && (
                                    <p
                                      className={`text-[16px] font-normal mb-1 m-0 ${
                                        isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                                      }`}
                                    >
                                      <span className="font-bold">HPR Id -</span>{' '}
                                      {reportDet?.signatureDetail?.footerTemplate?.hprId.trim()}
                                    </p>
                                  )}
                                  {reportDet?.signatureDetail?.footerTemplate?.specialization && (
                                    <p
                                      className={`text-[16px] font-normal mb-1 m-0 ${
                                        isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                                      }`}
                                    >
                                      <span className="font-bold">Specialization -</span>{' '}
                                      {reportDet.signatureDetail.footerTemplate.specialization.trim()}
                                    </p>
                                  )}
                                  {reportDet?.signatureDetail?.footerTemplate?.availability && (
                                    <p
                                      className={`text-[16px] font-normal mb-1 m-0 ${
                                        isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                                      }`}
                                    >
                                      <span className="font-bold">Availability -</span>{' '}
                                      {reportDet.signatureDetail.footerTemplate.availability.trim()}
                                    </p>
                                  )}
                                  {(
                                    reportDet?.authorizedUserRole === _roleType?.radiologist ||
                                    reportDet?.authorizedUserRole === _roleType?.pathologist ||
                                    reportDet?.authorizedUserRole === _roleType?.radiologistAdmin ||
                                    reportDet?.authorizedUserRole === _roleType?.pathologistAdmin
                                  ) &&
                                    reportDet?.authorizedOn && (
                                      <p
                                        className={`text-[16px] font-normal mb-1 m-0 ${
                                          isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                                        }`}
                                      >
                                        <span className="font-bold">Authorized On -</span>{' '}
                                        {formatDate(reportDet?.authorizedOn, 'withTime')}
                                      </p>
                                  )}
                                  {[
                                    _roleType?.radiologist,
                                    _roleType?.pathologist,
                                    _roleType?.radiologistAdmin,
                                    _roleType?.pathologistAdmin
                                  ].includes(reportDet?.authorizedUserRole) && (
                                    <span
                                      className={`text-[16px] font-normal ${
                                        isDarkMode?.isDarkMode ? 'text-white' : 'text-black'
                                      }`}
                                    >
                                      This is a system generated report. Personal signature may not be required.
                                    </span>
                                  )}
                                </>
                              ) : (
                                <>
                                  <p className="text-[22px] font-semibold">
                                    {(reportDet?.authorizedUserRole === _roleType?.radiologist || reportDet?.authorizedUserRole === _roleType?.pathologist || reportDet?.authorizedUserRole === _roleType?.radiologistAdmin || reportDet?.authorizedUserRole === _roleType?.pathologistAdmin) ? 'Dr. ' : ''}
                                    {cleanPrefixFromName(reportDet?.authorizedUserName)}
                                    {reportDet?.authorizedPersonQualification && ` (${reportDet.authorizedPersonQualification})`}
                                  </p>
                                  {(reportDet?.authorizedUserRole) && (
                                    <p className='text-[16px] font-normal mb-1'>
                                      {reportDet?.authorizedUserRole}
                                    </p>
                                  )}
                                  {reportDet?.signatureDetail?.licenseNumber && <p className='text-[16px] font-normal mb-1'><span className='font-bold'>License Number -</span> {reportDet?.signatureDetail?.licenseNumber}</p>}
                                  {reportDet?.signatureDetail?.specialization && reportDet?.signatureDetail?.specialization.length > 0 && <p className='text-[16px] font-normal mb-1'><span className='font-bold'>Specialization - </span>{reportDet?.signatureDetail?.specialization.join(", ")}</p>}
                                  {reportDet?.signatureDetail?.availabilityDay?.length > 0 && (
                                    <p className='text-[16px] font-normal mb-1'>
                                      <span className='font-bold'>Availability Day - </span>
                                      {formatDays(reportDet?.signatureDetail?.availabilityDay)}
                                      {reportDet?.signatureDetail?.fromTimeAvailability && reportDet?.signatureDetail?.toTimeAvailability
                                        ? `, ${formatTime(reportDet.signatureDetail.fromTimeAvailability, true)} - ${formatTime(reportDet.signatureDetail.toTimeAvailability, true)}`
                                        : null}
                                    </p>
                                  )}
                                  {reportDet?.authorizedOn && (
                                    <p className='text-[16px] font-normal mb-1'>
                                      <span className='font-bold'>Authorized On - </span>
                                      {formatDate(reportDet?.authorizedOn, 'withTime')}
                                    </p>
                                  )}
                                  <span className='text-[16px] font-normal'>This is a system generated report. Personal signature may not be required.</span>
                                </>
                              )}
                            </section>
                          </>
                        )}

                        {reportDet?.images?.length > 0 && (
                          <ImagePreview
                            images={reportDet?.images}
                            reportDet={reportDet}
                            setReportDet={setReportDet}
                            setImgPreviewPg={setImgPreviewPg}
                          />
                        )}

                        {reportDet?.shareReport && reportDet?.rollbackStatus && <p className='text-[14px] font-normal mb-2'>**Note - The previous report contained some errors, so we kindly ask you to ignore it. Please consider the new report instead.</p>}
                        <div className='bg-[#0F8491] pt-2 pb-2 pr-2 pl-2'>
                          <div className='flex flex-row gap-4 justify-between items-center border-t-2 border-[#0F8491] text-white'>
                            {(hospitalDetail?.hospitalFooter?.contactNumber || hospitalDetail?.contactNumber) && (
                              <div className='flex flex-row gap-2'>
                                <img src={phoneIconWhite} alt="" />
                                <p className='text-[14px] font-normal text-white'>{hospitalDetail?.hospitalFooter?.contactNumberCountryCode ? hospitalDetail?.hospitalFooter?.contactNumberCountryCode : hospitalDetail?.contactNumberCountryCode} {hospitalDetail?.hospitalFooter?.contactNumber ? hospitalDetail?.hospitalFooter?.contactNumber : hospitalDetail?.contactNumber}</p>
                              </div>
                            )}
                            {hospitalDetail?.hospitalFooter?.email || hospitalDetail?.hospitalEmailId && (
                              <div className='flex flex-row gap-2'>
                                <img src={mailIconwhite} alt="" />
                                <p className='text-[10px] font-normal text-white'>{hospitalDetail?.hospitalFooter?.email ? hospitalDetail?.hospitalFooter?.email : hospitalDetail?.hospitalEmailId}</p>
                              </div>
                            )}
                            {(hospitalDetail?.hospitalHeader?.address || hospitalDetail?.address) && (
                              <div className='flex flex-row gap-2'>
                                <img src={mapIconWhite} alt="" />
                                <p className='text-[14px] font-normal text-white'>{getAddress(hospitalDetail)}</p>
                              </div>
                            )}
                            {hospitalDetail?.hospitalHeader?.website || hospitalDetail?.website && (
                              <div className='flex flex-row gap-2'>
                                <img src={websiteIcon} alt="" />
                                <p className='text-[14px] font-normal color-[#535353]'>{hospitalDetail?.hospitalHeader?.website ? hospitalDetail?.hospitalHeader?.website : hospitalDetail?.website} </p>
                              </div>
                            )}
                          </div>
                        </div>

                      </div>
                      {(reportDet?.name && (reportDet.status !== _reportStatus.Authorized)) && <div className="watermark-text2" style={{ color: getWaterStyle(reportDet?.status === 'Send for Review' ? reportDet?.oldStatus : reportDet?.status) }}>{reportDet?.status === 'Send for Review' ? reportDet?.oldStatus : reportDet?.status}</div>}
                      {imgPreviewPg && <ImagePreview setImgPreviewPg={setImgPreviewPg} images={reportDet?.images} reportDet={reportDet} setReportDet={setReportDet} />}
                    </div>
                }
              </section>
            </div>
          </div>
        </div>
      </div>
      <RollbackModal isOpen={isModalOpen} onClose={handleCloseModal} reportid={reportId} />
      <Loader isLoaderOpen={isLoading || isPrinting} />
      <ShareModal isOpen={isshareModalOpen} onClose={handleCloseshareModal} reportid={reportId} reportDet={reportDet} />
    </>
  )
}
